import { defineComponent as _defineComponent } from 'vue'
import { computed } from '@nuxtjs/composition-api';
import BravadoButtonV3 from '@/components/common/BravadoButtonV3/BravadoButtonV3.vue';

type CardExampleProps = {
  shared: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'PublicPortfolioHeadlineShareButton',
  props: {
    shared: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  shared: boolean;
};



const rootClass = computed(() => ({
  'public-portfolio-headline-share-button': true,
  'public-portfolio-headline-share-button--shared': props.shared,
}));
const icon = computed(() => require(`./images/${props.shared ? 'shared-icon' : 'share-icon'}.svg`));
const buttonTitle = computed(() => (props.shared ? 'Shared' : 'Not Shared'));

return { __sfc: true,props, rootClass, icon, buttonTitle, BravadoButtonV3 }
}

})